export default [
    {
        path: '/seatsearch', // 选座搜索
        component: resolve => require(['@/pages/seat/search'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/seatlist', // 选座航班列表
        component: resolve => require(['@/pages/seat/flightlist'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/seatchat', // 选座座位图
        component: resolve => require(['@/pages/seat/seatchat'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/seatorderlist', // 座位订单列表
        component: resolve => require(['@/pages/seat/seatOrderList'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/seatconfirm', // 座位订单列表
        component: resolve => require(['@/pages/seat/seatconfirm'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/seatsuccess/:id', // 选座成功页
        component: resolve => require(['@/pages/seat/seatSuccess'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/seatorderdetail/:id', // 选座详情页
        component: resolve => require(['@/pages/seat/seatOrderDetail'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/seatneedinfo', // 选座须知
        component: resolve => require(['@/pages/inforule/seatneedinfo'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/lookBoarding', // 查看登机牌
        component: resolve => require(['@/pages/seat/lookBoarding'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/seatSuccessList', // 由订单详情页跳转过的  选座信息页面
        component: resolve => require(['@/pages/seat/seatSuccessList'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/lookBoardingOne', // 查看登机牌22
        component: resolve => require(['@/pages/seat/lookBoardingOne'], resolve),
        meta: { title: "长龙航空" }
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/seat.js